import { IoArrowBackSharp } from "react-icons/io5";
import DisplayUsers from "./auxiliary/DisplayUsers";
import { useNavigate, useParams } from "react-router-dom";
import { getRequest, postRequest } from "../apiRequests/requestApi";
import { useEffect, useState } from "react";

const QuickMatch = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { lobbyCode, currentPlayerId, gameName, lobbyId, gameId } = useParams();
  const navigate = useNavigate();
  console.log({ lobbyCode, currentPlayerId, gameName, lobbyId, gameId });

  useEffect(() => {
    const fetchBotData = async () => {
      try {
        const response = await getRequest(`/quick-match/${lobbyCode}`);
        setUsers(response?.data ? [response.data] : []);
      } catch (error) {
        console.error("Error fetching bot data:", error);
        setUsers([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBotData();
  }, [lobbyCode]);

  const handleClick = async (users) => {
    const opponentId = users.user_id || users.userID || users._id || users.id;

    const opponentAvatar = users.avatar || "";
    const opponentName = users.username || "Player";

    if (gameId && opponentId && currentPlayerId && lobbyCode) {

      const gameUrl = `/games/selected-user/${gameId}/${currentPlayerId}/${opponentId}/${opponentName}/${lobbyId}/${lobbyCode}/${gameName}?avatar=${encodeURIComponent(
        opponentAvatar
      )}`;

      console.log("Navigating to game URL:", gameUrl);

      try {
        await postRequest({
          url: "/gamers/select",
          data: {
            playerId: opponentId,
            lobbyId,
          },
        });
      } catch (error) {
        console.error("Player selection API failed, proceeding anyway:", error);
      }

      navigate(gameUrl);
    } else {
      console.warn("Missing game parameters; cannot proceed with game setup.");
    }
  };

  console.log(users);
  return (
    <div className="w-full min-h-screen flex flex-col px-4 bg-[#130828] py-3">
      <div className="">
        <div className="flex items-center mb-4">
          <button onClick={() => navigate(-1)} className="mr-4">
            <IoArrowBackSharp size={24} className="text-white" />
          </button>
          <h1 className="text-xl text-white font-bold text-center my-8">
            Quick <span className="text-[#FF43B9]">Match</span>
          </h1>
        </div>

        {isLoading ? (
          <p className="text-center text-white mt-10">Loading players...</p>
        ) : users.length === 0 ? (
          <p className="text-center text-white mt-10">No players found.</p>
        ) : (
          <DisplayUsers
            users={users}
            btnTxt="Play"
            btnFunc={handleClick}
            accountType="celebrity"
          />
        )}
      </div>
    </div>
  );
};

export default QuickMatch;
